import { render, staticRenderFns } from "./cms.vue?vue&type=template&id=45670a63&"
import script from "./cms.js?vue&type=script&lang=js&"
export * from "./cms.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports